export type CacheBackend<V> = {
  get(key: string): Promise<undefined | V>
  set(key: string, value: V): Promise<void>
  delete(key: string): Promise<void>
  clear(): Promise<void>
  exists(key: string): Promise<boolean>
}

export type SearchCacheBackend<V> = {
  startswith(prefix?: string): Promise<Record<string, V>>
} & CacheBackend<V>
